// extracted by mini-css-extract-plugin
export default {"imageContent":"Io-z","modal":"Jo-z"};